import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { RCCHookToast, RCCRefModalProps, RCCServicesApi } from "react-common-components";
import { useForm } from "react-hook-form";
import Modal from "src/components/Modal";
import { useTranslation } from "src/context/Translations/context";
import { getValidationErrors, standardErrorMessages } from "src/utils/errors";
import ModalSide from "src/components/Modal/styles";
import Permissions from "src/components/Permissions";
import Title from "src/components/Title";
import { IDatba004, IRefDashboardModalsShare } from "./interface";
import addAndChangeSchema from "./schemas";

const ModalShareDashboard: React.ForwardRefRenderFunction<IRefDashboardModalsShare> = (_, ref) => {
	const { translate } = useTranslation();
	const {addToast} = RCCHookToast();

	const [selectedDashboard, setSelectedDashboard] = useState<number>(0);
	const [subtitle, setSubtitle] = useState("");
	const [defaultPermissions, setDefaultPermissions] = useState<IDatba004[]>([]);

	// Modal Share
	const modalShare = useRef<RCCRefModalProps>(null);
	const { handleSubmit, register, reset, setError, control, formState: { errors }, clearErrors, unregister } = useForm();
	const submitShare = async (data: any) => {
		try{
			clearErrors();
			modalShare.current?.setLoadingButton();

			const datba004Efa005 = data.datba004?.filter((x: any) => !x.daa004Efa004Id).map((x: any) => ({
				...x,
				daa004Efa005Id: typeof x.daa004Efa005Id === "object" ? x.daa004Efa005Id.value : x.daa004Efa005Id
			})) ?? [];
			const datba004Efa004 = data.datba004?.filter((x: any) => !x.daa004Efa005Id).map((x: any) => ({
				...x,
				daa004Efa004Id: typeof x.daa004Efa004Id === "object" ? x.daa004Efa004Id.value : x.daa004Efa004Id
			})) ?? [];

			const dataForm = {
				datba004: [
					...datba004Efa004,
					...datba004Efa005
				]
			};

			await addAndChangeSchema(translate).validate({...dataForm}, {
				abortEarly: false
			});

			await RCCServicesApi.postRequest({
				method: "Dashboard/Share",
				body: {
					dashboardId: selectedDashboard,
					datba004: dataForm.datba004
				}
			});

			addToast({
				color: "green",
				description: translate("Dashboard compartilhada com sucesso"),
				title: translate("Sucesso")
			});

			modalShare.current?.resetLoadingButton();
			modalShare.current?.closeModal();
		}catch(err){

			modalShare.current?.resetLoadingButton();
			if(getValidationErrors(err, setError))
				return;

			standardErrorMessages(err, translate("Erro ao compartilhar dashboard"), addToast);
		}
	};
	const actionButtonShare = async (id: number, title: string) => {
		try{
			reset(); 
			const response = await RCCServicesApi.getRequest({
				method: "Dashboard/GetPermissions",
				urlParameters: {
					id
				}
			});
			setSelectedDashboard(id); 
			setSubtitle(title);
			setDefaultPermissions(response.data as IDatba004[]);
			modalShare.current?.openModal();

		}catch(err){
			standardErrorMessages(err, translate("Erro ao buscar dados"), addToast);
		}
	};
	
	useImperativeHandle(ref, () => ({
		actionButtonShare
	}));
    
	return (
		<>	
			{/* Modal ADD/CHANGE */}
			<Modal
				ref={modalShare}
				header={{
					title: `${translate("Compartilhar")} dashboard`,
					icon: {
						name: "users"
					}
				}}
				onSubmit={handleSubmit(submitShare)}
				styleInline={ModalSide}
			>
				<Title color="purple" marginBottom={16}>
					Dashboard: {subtitle}
				</Title>
				<Permissions
					register={register}
					unregister={unregister}
					control={control}
					error={errors}
					clearErrors={clearErrors}
					permissionType="hidePermissions"
					permissionsNames= {{
						nameObject: "datba004",
						nameOfID: "daa004Id",
						nameOfSelectUserDescription: "daa004Efa005Nome",
						nameOfSelectGroupDescription: "daa004Efa004Descricao",
						nameOfSelectUser: "daa004Efa005Id",
						nameOfSelectGroup: "daa004Efa004Id",
						defaultValue: defaultPermissions
					}}
				/>
			</Modal>
		</>
	);
};

export default forwardRef(ModalShareDashboard);
